import React, { useEffect, useState } from "react";
import Card from "./Card";
import KCard from "./KCard";
import SearchImage from "./SearchImage";
import { SCALESERP_API_REQUEST_URL, SCALESERP_SEARCH_PARAMS } from "../config";

import styles from "./CreateKCard.module.css";

const CreateKCard = function (props) {
  const [img, setImage] = useState("");
  const [query, setQuery] = useState("");
  const [translation, setTranslation] = useState("");
  const [info, setInfo] = useState("");
  const [imageSearch, setImageSearch] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = function (e) {
      setWindowWidth(e.target.innerWidth);
    };
    window.addEventListener("resize", handleWindowResize);
  }, []);

  const handleSearchSubmission = async function (value) {
    setIsLoading(true);
    // SETTING IMAGE MANUALLY
    if (value.startsWith("http")) {
      setImage(value);
      setIsLoading(false);
      return;
    }

    if (value.length === 0) {
      setImage(value);
      setIsLoading(false);
      return;
    }
    setQuery(value);

    // TRANSLATE
    // https://stackoverflow.com/questions/26714426/what-is-the-meaning-of-google-translate-query-params/29537590#29537590
    try {
      const resTranslate = await fetch(
        `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${props.inputLang}&tl=${props.outputLang}&dt=t&q=${value}`,
        {
          "Content-Type": "application/json",
        }
      );
      const jsonTranslate = await resTranslate.json();
      const translateResult = jsonTranslate[0][0][0];
      setTranslation(translateResult);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }

    // IMAGE SEARCH
    SCALESERP_SEARCH_PARAMS.set("q", value);
    try {
      const resImage = await fetch(
        `${SCALESERP_API_REQUEST_URL}?${SCALESERP_SEARCH_PARAMS}`
      );
      const jsonImage = await resImage.json();

      if (!resImage.ok)
        throw new Error(`${resImage.status} - ${jsonImage.message}`);

      const images = jsonImage.image_results.map((result) => result.image);
      setImageSearch(images);
      setImage(images[0]);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }

    setIsLoading(false);
  };

  const clear = function () {
    setImage("");
    setQuery("");
    setTranslation("");
    setInfo("");
    setImageSearch([]);
  };

  return (
    <div className={styles.container}>
      {windowWidth > 425 && (
        <SearchImage
          className={styles["search-above"]}
          onSearchSubmit={handleSearchSubmission}
        ></SearchImage>
      )}
      <Card>
        {windowWidth <= 425 && (
          <SearchImage
            className={styles["search-within"]}
            onSearchSubmit={handleSearchSubmission}
          ></SearchImage>
        )}

        <KCard
          img={img}
          query={query}
          result={translation}
          info={info}
          inputLang={props.inputLang}
          outputLang={props.outputLang}
          imageSearch={imageSearch}
          onQueryChange={setQuery}
          onResultChange={setTranslation}
          onInfoChange={setInfo}
          onImageChange={setImage}
          isLoading={isLoading}
          updateLocalCollection={props.updateLocalCollection}
          collection={props.collection}
          onClear={clear}
        ></KCard>
      </Card>
    </div>
  );
};

export default CreateKCard;
